import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { PhotosByEvent, SeasonContext } from '../../../../types';
import AvatarCarouselPanel from './AvatarCarouselPanel';
import AvatarBubble from './AvatarBubble';
import { AddEventButton } from '../../../admin/AddEventButton';
import '../../../shared/SeasonShell.css';
import './AvatarCarousel.css';

interface AvatarCarouselPresentationProps {
  sortedEvents: [string, PhotosByEvent[string]][];
  openEvent: string | null;
  openEventData: PhotosByEvent[string] | undefined;
  seasonContext?: SeasonContext;

  trackRef: React.RefObject<HTMLDivElement | null>;
  onTrackScroll: () => void;
  onTrackKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => void;

  onAvatarClick: (event: string | null) => void;
  onPrev: () => void;
  onNext: () => void;

  canGoPrev: boolean;
  canGoNext: boolean;
}

const AvatarCarouselPresentation: React.FC<AvatarCarouselPresentationProps> = ({
  sortedEvents,
  openEvent,
  openEventData,
  seasonContext,
  trackRef,
  onTrackScroll,
  onTrackKeyDown,
  onAvatarClick,
  onPrev,
  onNext,
  canGoPrev,
  canGoNext
}) => {
  return (
    <div className="avatar-carousel-wrapper">
      <div
        className={`season-shell avatar-carousel-container${openEvent ? ' panel-open' : ''}`}
        aria-label="Stories carousel"
      >
        <button
          onClick={onPrev}
          disabled={!canGoPrev}
          aria-label="Previous stories"
          className="avatar-carousel-arrow left"
        >
          {'<'}
        </button>
        
        <button
          onClick={onNext}
          disabled={!canGoNext}
          aria-label="Next stories"
          className="avatar-carousel-arrow right"
        >
          {'>'}
        </button>
        
        <div
          ref={trackRef}
          className="avatar-carousel-track"
          onScroll={onTrackScroll}
          onKeyDown={onTrackKeyDown}
        >
          {sortedEvents.map(([eventName, eventData]) => (
            <AvatarBubble
              key={eventName}
              eventName={eventName}
              eventData={eventData}
              isOpen={openEvent === eventName}
              onAvatarClick={onAvatarClick}
            />
          ))}

          {seasonContext && (
            <AddEventButton
              seasonId={seasonContext.seasonId}
              seasonName={seasonContext.seasonName}
              year={seasonContext.year}
            />
          )}
        </div>
      </div>
      
      <AnimatePresence>
        {openEventData && (
          <AvatarCarouselPanel
            isOpen={!!openEvent}
            event={openEvent}
            photos={openEventData.photos}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default AvatarCarouselPresentation;
